import { render } from "./WhatsAppPayment.vue?vue&type=template&id=571ec074"
import script from "./WhatsAppPayment.vue?vue&type=script&lang=js"
export * from "./WhatsAppPayment.vue?vue&type=script&lang=js"

import "./WhatsAppPayment.vue?vue&type=style&index=0&id=571ec074&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__